import { DarkVenueHeatmapApiOkResponse } from 'widgets/darkVenueHeatmap/api/DarkVenueHeatmapApiResponse.ts';
import TreemapChart from 'utils/components/TreemapChart/TreemapChart.tsx';
import React, { useMemo } from 'react';
import { useWidgetContext } from 'widgets/WidgetContext.tsx';
import { tinygradient } from 'tinygradient';
import { TreemapPoint } from 'react-vis';
import { max } from 'lodash';
import { VenueMappingsResponse } from './venueMappings/types';
import { TreemapNode } from 'utils/components/TreemapChart/treemapData';

// Low Liquidity: light gray (#F0F0F0)
// Low-Medium Liquidity: Medium gray (#A6A9AA)
// Medium liquidity: Aqua green ( #00AF89)
// Medium-high Liquidity: Deep Teal (#008C95)
// High Liquidity: Dark greenish teal: (#00796B)

const gradient = tinygradient(
    '#F0F0F0',
    '#A6A9AA',
    '#00AF89',
    '#008C95',
    '#00796B'
);

type TreeMapDataItem = TreemapNode & { description: string };

export default function DarkVenueHeatmapChart({
    data,
    height,
    mappings,
}: {
    data: DarkVenueHeatmapApiOkResponse;
    height: number;
    mappings: VenueMappingsResponse;
}) {
    const { width } = useWidgetContext();

    const treemapData = useMemo(
        () =>
            Object.keys(data.venueWeights).map<TreeMapDataItem>((k) => ({
                name: k + ' ',
                value: data.venueWeights[k],
                description: mappings[k],
            })),
        [data, mappings]
    );

    const colorScale = max(treemapData.map((d) => d.value)) ?? 1;

    return (
        <div className="DarkVenueHeatmapChart">
            <TreemapChart
                canDrilldown={false}
                showOtherDrilldown={false}
                width={width}
                height={height}
                data={treemapData}
                percentGroupingThreshold={0}
                isSideSummary={false}
                labelPrecision={1}
                labelHidePercentSign={false}
                getColor={(d: TreemapPoint) => {
                    return gradient.rgbAt(d.value / colorScale);
                }}
                getTooltip={(data) => data?.description ?? data?.name}
            />
        </div>
    );
}
